import { Snackbar, Alert } from "@mui/material";
import React from "react";

let showToast: (msg: string, severity?: "success" | "info" | "warning" | "error") => void = () => {};

export function triggerToast(msg: string, severity: "success" | "info" | "warning" | "error" = "info") {
  showToast(msg, severity);
}

export const GlobalToast: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [severity, setSeverity] = React.useState<"success" | "info" | "warning" | "error">("info");

  React.useEffect(() => {
    showToast = (msg, sev) => {
      setMessage(msg);
      setSeverity(sev || "info");
      setOpen(true);
    };
  }, []);

  const handleClose = (_event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};
